import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../api';
import { useSubscription } from '../hooks/useSubscription';
import Sidebar from '../components/Sidebar';
import { useIsMobile } from '../hooks/useIsMobile';
import { T } from '../styles/theme';

const freeFeatures = [
  { label: 'Dashboard base', ok: true },
  { label: 'Corso completo', ok: true },
  { label: 'Inventario', ok: true },
  { label: 'Fornitori', ok: true },
  { label: 'Vendite', ok: true },
  { label: 'Best Product', ok: false },
  { label: 'Analisi Mercato AI', ok: false },
  { label: 'Annunci AI', ok: false },
  { label: 'Bozze + Editor foto', ok: false },
  { label: 'Chatbot AI H24', ok: false },
  { label: 'Estensione Chrome', ok: false },
];
const proFeatures = [
  'Tutto il piano FREE',
  'Best Product picks',
  'Analisi Mercato AI',
  'Annunci AI wizard',
  'Bozze + Editor foto',
  'Pubblicazione Vinted/eBay',
  'Chatbot AI H24',
  'Estensione Chrome completa',
  'Supporto prioritario',
];

export default function Abbonamento() {
  const [searchParams] = useSearchParams();
  const { subscription, isPro, loading } = useSubscription();
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const [portalLoading, setPortalLoading] = useState(false);
  const isMobile = useIsMobile();
  const success = searchParams.get('success');
  const canceled = searchParams.get('canceled');

  const handleUpgrade = async () => {
    setCheckoutLoading(true);
    try {
      const res = await api.post('/stripe/checkout');
      window.location.href = res.data.checkout_url;
    } catch (e) {
      alert(e.response?.data?.detail || 'Errore Stripe');
      setCheckoutLoading(false);
    }
  };

  const handlePortal = async () => {
    setPortalLoading(true);
    try {
      const res = await api.get('/stripe/portal');
      window.location.href = res.data.portal_url;
    } catch {
      alert('Abbonamento non trovato. Contatta il supporto.');
      setPortalLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: T.bg }}>
      <Sidebar />
      <main style={{ flex: 1, marginLeft: isMobile ? 0 : 220, padding: isMobile ? '16px' : '32px 40px', paddingTop: isMobile ? 72 : 56, overflowX: 'hidden' }} className="main-content">
        <h1 className="page-title" style={{ marginBottom: 8 }}>Abbonamento</h1>
        <p style={{ color: T.muted, fontSize: '0.9rem', marginBottom: 24 }}>Scegli il piano adatto a te</p>

        {success === 'true' && (
          <div style={{ background: 'rgba(74,222,128,0.1)', border: '1px solid #4ade80', borderRadius: 14, padding: 16, marginBottom: 20, color: '#4ade80', fontSize: '0.88rem', textAlign: 'center' }}>
            🎉 Abbonamento PRO attivato con successo! Benvenuto nel team PRO.
          </div>
        )}
        {canceled === 'true' && (
          <div style={{ background: 'rgba(248,113,113,0.1)', border: '1px solid #f87171', borderRadius: 14, padding: 16, marginBottom: 20, color: '#f87171', fontSize: '0.88rem', textAlign: 'center' }}>
            Pagamento annullato. Puoi riprovare quando vuoi.
          </div>
        )}

        {/* CARDS */}
        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(300px, 1fr))', gap: 20, marginBottom: 24 }}>
          {/* FREE */}
          <div className="card" style={{ padding: 28, position: 'relative' }}>
            <div style={{ fontSize: '0.72rem', fontWeight: 700, color: T.muted, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 8 }}>Piano Free</div>
            <div style={{ fontFamily: 'Syne,sans-serif', fontSize: '2rem', fontWeight: 800, color: T.text, marginBottom: 4 }}>{'\u20AC'}0<span style={{ fontSize: '0.85rem', fontWeight: 400, color: T.muted }}>/mese</span></div>
            <p style={{ fontSize: '0.82rem', color: T.muted, marginBottom: 20 }}>Per iniziare a esplorare il reselling</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {freeFeatures.map(f => (
                <div key={f.label} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.82rem', color: f.ok ? T.text : T.muted }}>
                  <span style={{ color: f.ok ? T.green : T.muted }}>{f.ok ? '\u2713' : '\u2715'}</span>
                  <span style={{ textDecoration: f.ok ? 'none' : 'line-through' }}>{f.label}</span>
                </div>
              ))}
            </div>
            {!isPro && <div style={{ marginTop: 20, padding: '10px 20px', background: T.elem, borderRadius: 9999, textAlign: 'center', color: T.muted, fontSize: '0.82rem', fontWeight: 600 }}>Piano attuale</div>}
          </div>

          {/* PRO */}
          <div style={{ background: 'linear-gradient(135deg,#7c3aed,#2d1f6e)', borderRadius: 21, padding: 1, position: 'relative' }}>
            <div style={{ position: 'absolute', top: -10, right: 20, background: 'linear-gradient(135deg,#fbbf24,#f59e0b)', color: '#000', padding: '4px 14px', borderRadius: 9999, fontSize: '0.68rem', fontWeight: 800, textTransform: 'uppercase' }}>Consigliato</div>
            <div className="card" style={{ padding: 28, borderRadius: 20, height: '100%' }}>
              <div style={{ fontSize: '0.72rem', fontWeight: 700, color: T.violet, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 8 }}>Piano PRO</div>
              <div style={{ fontFamily: 'Syne,sans-serif', fontSize: '2rem', fontWeight: 800, color: T.text, marginBottom: 4 }}>{'\u20AC'}35<span style={{ fontSize: '0.85rem', fontWeight: 400, color: T.muted }}>/mese</span></div>
              <p style={{ fontSize: '0.82rem', color: T.muted, marginBottom: 20 }}>Tutto il necessario per vendere come un pro</p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 24 }}>
                {proFeatures.map(f => (
                  <div key={f} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.82rem', color: T.text }}>
                    <span style={{ color: T.green }}>{'\u2713'}</span>{f}
                  </div>
                ))}
              </div>
              {isPro ? (
                <div style={{ padding: '10px 20px', background: 'rgba(74,222,128,0.1)', border: '1px solid #4ade80', borderRadius: 9999, textAlign: 'center', color: '#4ade80', fontSize: '0.82rem', fontWeight: 700 }}>
                  {'\u2B50'} Piano attuale
                </div>
              ) : (
                <button onClick={handleUpgrade} disabled={checkoutLoading} style={{ width: '100%', padding: '12px 28px', background: 'linear-gradient(135deg,#7c3aed,#4f46e5)', color: 'white', border: 'none', borderRadius: 9999, fontFamily: 'DM Sans,sans-serif', fontWeight: 700, fontSize: '0.9rem', cursor: 'pointer', boxShadow: '0 4px 16px rgba(124,58,237,0.4)', opacity: checkoutLoading ? 0.6 : 1 }}>
                  {checkoutLoading ? 'Reindirizzamento...' : '\u26A1 Passa a PRO \u2014 \u20AC35/mese'}
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Gestione abbonamento — solo per utenti PRO con Stripe */}
        {isPro && subscription?.has_stripe && (
          <div style={{ background: '#1a1035', border: '1px solid #2d1b69', borderRadius: 16, padding: 24, marginBottom: 24 }}>
            <h3 style={{ fontFamily: 'Syne,sans-serif', fontSize: '1rem', fontWeight: 700, color: T.text, marginBottom: 8 }}>Gestione abbonamento</h3>
            <p style={{ fontSize: '0.82rem', color: T.muted, lineHeight: 1.6, marginBottom: 16 }}>
              Gestisci il tuo abbonamento Stripe — modifica metodo di pagamento, scarica fatture o annulla quando vuoi.
            </p>
            {subscription?.scadenza && (
              <p style={{ fontSize: '0.78rem', color: T.muted, marginBottom: 16 }}>
                Prossimo rinnovo: <span style={{ color: T.text, fontWeight: 600 }}>{new Date(subscription.scadenza).toLocaleDateString('it-IT')}</span>
              </p>
            )}
            <button onClick={handlePortal} disabled={portalLoading}
              style={{ padding: '10px 24px', background: 'transparent', border: '1px solid #a78bfa', borderRadius: 9999, color: '#a78bfa', fontFamily: 'DM Sans,sans-serif', fontWeight: 700, fontSize: '0.85rem', cursor: 'pointer', transition: '0.15s', opacity: portalLoading ? 0.6 : 1 }}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(167,139,250,0.1)'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
              {portalLoading ? 'Caricamento...' : '\u2699\uFE0F Gestisci abbonamento'}
            </button>
            <p style={{ fontSize: '0.72rem', color: '#4b5563', marginTop: 8 }}>Verrai reindirizzato al portale sicuro Stripe</p>
          </div>
        )}

        {/* FAQ */}
        <div className="card" style={{ padding: 24 }}>
          <h2 className="section-title" style={{ color: T.violet, marginBottom: 16 }}>Domande frequenti</h2>
          {[
            { q: 'Posso cancellare in qualsiasi momento?', a: 'Si, puoi cancellare l\'abbonamento quando vuoi dal portale Stripe. Manterrai l\'accesso PRO fino alla fine del periodo pagato.' },
            { q: 'Come funziona il pagamento?', a: 'Pagamento sicuro tramite Stripe con carta di credito/debito. Rinnovo automatico mensile.' },
            { q: 'Posso fare upgrade/downgrade?', a: 'Puoi fare upgrade in qualsiasi momento. Il downgrade avviene alla fine del periodo corrente.' },
          ].map((faq, i) => (
            <div key={i} style={{ marginBottom: 16, paddingBottom: 16, borderBottom: i < 2 ? `1px solid ${T.border}` : 'none' }}>
              <p style={{ fontWeight: 600, fontSize: '0.88rem', color: T.text, marginBottom: 6 }}>{faq.q}</p>
              <p style={{ fontSize: '0.82rem', color: T.muted, lineHeight: 1.5 }}>{faq.a}</p>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
